export const SET_CITIES_LIST = 'SET_CITIES_LIST';
export const SET_POPULAR_CITIES_LIST = 'SET_POPULAR_CITIES_LIST';

export const setCitiesList = (cities) => ({
  type: SET_CITIES_LIST,
  payload: cities,
});

export const setPopularCitiesList = (cities) => ({
    type: SET_POPULAR_CITIES_LIST,
    payload: cities,
})